export default "__VITE_ASSET__eb7fb3be__"